import { getOpinionArticleType } from "@foundation/opinion-article-utils";
import { OPINION_ARTICLE_TYPE } from "@foundation/opinion-article-utils/lib/types";

import type { Person } from "~types/types";

function _getOpinionBylineText(authors: Person[]) {
    if (authors.length > 3) {
        const firstThreeAuthors = authors
            .slice(0, 3)
            .map(({ name }) => name)
            .join(", ");
        return `${firstThreeAuthors}, and more columnists`;
    }

    return authors.reduce((acc, { name }, idx, arr) => {
        if (idx === 0) {
            return name;
        }

        if (idx === arr.length - 1) {
            return `${acc} & ${name}, Columnists`;
        }
        return `${acc}, ${name}`;
    }, "");
}

export const getOpinionByline = (authors: Person[]) => {
    if (!authors) {
        return null;
    }

    const opinionArticleType = getOpinionArticleType(authors);

    if (opinionArticleType === OPINION_ARTICLE_TYPE.EDITORIAL_BOARD) {
        return "Editorial Board";
    }

    return _getOpinionBylineText(authors);
};

export function getOpinionBybrowPrefix(credits?: Person[]): string {
    if (!credits || credits.length !== 1) return "";

    const author = credits[0];

    const opinionArticleType = getOpinionArticleType([author]);

    switch (opinionArticleType) {
        case OPINION_ARTICLE_TYPE.COLUMNIST:
            return `Columnist`;
        case OPINION_ARTICLE_TYPE.GUEST_ESSAY:
            return `Guest Columnist`;
        default:
            return "";
    }
}
